import React from 'react';
import { useTranslation } from 'react-i18next';
import Layout from '../components/Layout';
import Back1 from '../assets/images/back-home-1.webp';
import SEO from '../components/SEO';
import DispersionPage from '../pages/DispersionPage';

export const Dispersion = () => {
  const { t, i18n } = useTranslation();
  return (
    <Layout backgroundimage={Back1} actionDemo={false}>
      <SEO
        title={t("Realiza dispersiones, automatiza y envía pagos masivos.")}
        description={t('Automatiza la dispersión de pagos y optimiza con nuestra plataforma financiera. Reduce errores y mejora la satisfacción de tus clientes.')}
        works={[
          t('Core Financiero'),
          t('Fintech'),
          t('Onboarding digital'),
          t('Aprobación de crédito'),
          t('Gestión de cobranza'),
          t('Análisis de crédito'),
          t('Core Bancario'),
          t('Automatización de procesos'),
          t('Procesos digitales'),
          t('Producto financiero'),
          t('Servicios financieros'),
          t('Digitalización de procesos'),
          t('Software financiero'),
          t('Dispersión'),
          t('Reportes automatizados'),
          t('Corebanking'),
          t('Sector financiero'),
          t('SOFIPO'),
          t('SOFOM'),
          t('CNBV'),
          t('Condusef'),
          t('Servicios financieros digitales'),
          t('Plataforma financiera'),
        ]}
        bolImage={false}
        ogImage={`beneficios_f.jpg`}
        twitterImage={`beneficios_t.jpg`}
        canonicalUrl={`https://dynamicore.io/${i18n.language === 'en' ? 'en/payment-dispersion' : 'dispersion-pagos'}`}
        hreflang={[
          { url: "https://dynamicore.io/dispersion-pagos", lang: "es" },
          { url: "https://dynamicore.io/en/payment-dispersion", lang: "en-us" }
        ]}
      />
      <DispersionPage/>
    </Layout>
  )
}
